import { SET_DEAL_DATA, SET_DEAL_SORT_ORDER, SET_DEAL_RESET_SORT, } from "./types";
export function setDealData(name, value) {
    return (dispatch) => {
        dispatch({ type: SET_DEAL_DATA, payload: { [name]: value } });
    };
}
export function changeDealListPageNo(page) {
    return (dispatch) => {
        dispatch({
            type: SET_DEAL_DATA,
            payload: {
                deals_page: page,
                deals_list_refetch: true,
                isdealsLoading: true,
                total_deals: 0,
                deals_list: [],
            },
        });
    };
}
export function changeDealListPerPage(perPage) {
    return (dispatch) => {
        dispatch({
            type: SET_DEAL_DATA,
            payload: {
                deals_perpage: perPage,
                deals_page: 1,
                deals_list_refetch: true,
                isdealsLoading: true,
                total_deals: 0,
                deals_list: [],
            },
        });
    };
}
export function changeSortOrder(column, newSortOrder) {
    return (dispatch) => {
        dispatch({
            type: SET_DEAL_SORT_ORDER,
            payload: { column, newSortOrder },
        });
        dispatch({
            type: SET_DEAL_DATA,
            payload: {
                deals_list_refetch: true,
                isdealsLoading: true,
                total_deals: 0,
                deals_list: [],
            },
        });
    };
}
export function openConfirmDealsPopup(data, confirmType) {
    return (dispatch) => {
        dispatch({
            type: SET_DEAL_DATA,
            payload: {
                confirm_deal_popup: true,
                disable_confirm_btn: false,
                dealData: data,
                confirmType,
            },
        });
    };
}
export function resetDealSortOrder() {
    return (dispatch) => {
        dispatch({ type: SET_DEAL_RESET_SORT });
        dispatch({
            type: SET_DEAL_DATA,
            payload: { deals_list_refetch_force: true },
        });
    };
}
export function openCheckKitListPopup(item) {
    return (dispatch) => {
        dispatch({
            type: SET_DEAL_DATA,
            payload: {
                selectKitItem: [item],
                checkKitPopStatus: true,
                kitItems: [],
            },
        });
    };
}
export function changeKitPageNo(page) {
    return (dispatch) => {
        dispatch({
            type: SET_DEAL_DATA,
            payload: { kitPage: page, kitLoading: true },
        });
    };
}
export function openActiveDealCompleteListPopup(list) {
    return (dispatch) => {
        dispatch({
            type: SET_DEAL_DATA,
            payload: {
                completeDealList: list,
                completeDealListOpen: true,
            },
        });
    };
}
export function closeActiveDealCompleteListPopup() {
    return (dispatch) => {
        dispatch({
            type: SET_DEAL_DATA,
            payload: {
                completeDealList: [],
                completeDealListOpen: false,
            },
        });
    };
}
export function openConfirmArchivePopup(confirmType = "bulkArchive") {
    return (dispatch) => {
        dispatch({
            type: SET_DEAL_DATA,
            payload: {
                confirm_deal_popup: true,
                disable_confirm_btn: false,
                confirmType,
            },
        });
    };
}
export function closeNextArchivePopup() {
    return (dispatch) => {
        dispatch({
            type: SET_DEAL_DATA,
            payload: {
                nextArchiveConfirmPopup: false,
                bulkArchiveItems: [],
                archiveData: [],
                nextBtnDisable: false,
                archiveArray: [],
            },
        });
    };
}
